import { fabric } from "@utils/fabric";
import { TypeStrikethrough } from "react-bootstrap-icons";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";

function FontLinethrough() {
  const { canvas, selectedObject } = useContext(AppContext);
  const [linethrough, setLinethrough] = useState(
    (selectedObject as fabric.Textbox)?.linethrough
  );

  // triggered by clicking layers
  useEffect(() => {
    setLinethrough((selectedObject as fabric.Textbox)?.linethrough);
  }, [selectedObject]);

  function onClick() {
    setLinethrough(!linethrough);
    (selectedObject as fabric.Textbox)?.set({ linethrough: !linethrough });
    canvas?.renderAll();
  }

  return (
    <button
      className={`flex items-center justify-center h-9 w-9 rounded-lg border transition-all duration-200 ${
        linethrough 
          ? "bg-blue-500 border-blue-500 text-white shadow-sm" 
          : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400"
      }`}
      onClick={onClick}
    >
      <TypeStrikethrough size={16} />
    </button>
  );
}

export default FontLinethrough;
